// extracted by mini-css-extract-plugin
export var borderRadius = "_eu-4";
export var large = "_eu-3";
export var logoContainer = "_eu-0";
export var nameLogo = "_eu-2";
export var small = "_eu-1";